import { object, string, boolean, ObjectSchema } from 'yup';

// Note: here we are using makeValidationSchema (a method) instead of directly exporting
// a validationSchema because the called method (in this case, shape) depends on an
// external library that needs to be mocked before the call is made. If the result of
// shape is exported directly, jest cannot overwrite the mock to return a differente value
// to test all possible branches. This will probably be the case in most validationSchemas
// that depend on more than just constants.
const makeValidationSchema = (): ObjectSchema => {
  const maxCharacterPreiousDamage = 250;
  const maxCharacterCarImprovements = 250;
  const equalCharacterLicensePlate = 6;
  const maxCharacterVinNumber = 17;
  const maxCharacterSerialMotor = 20;

  function createMaxRegex(maxCharacter: number): RegExp {
    return new RegExp(`^.{0,${maxCharacter}}$`);
  }

  function createEqualCantRegex(maxCharacter: number): RegExp {
    return new RegExp(`^[a-zA-Z0-9]{${maxCharacter}}$`);
  }

  return object().shape({
    isCollective: boolean(),
    hasLicense: boolean(),
    previousDamage: string().matches(
      createMaxRegex(maxCharacterPreiousDamage),
      {
        message: `La cantidad de carácteres no puede ser mayor a ${maxCharacterPreiousDamage}`,
      },
    ),
    carImprovements: string().matches(
      createMaxRegex(maxCharacterCarImprovements),
      {
        message: `La cantidad de carácteres no puede ser mayor a ${maxCharacterCarImprovements}`,
      },
    ),
    vinNumber: string().when('hasLicense', {
      is: false,
      then: string()
        .nullable()
        .required('El campo del número de chasis es obligatorio')
        .min(10, 'El campo de número de chasis debe tener mínimo 10 caracteres')
        .matches(createMaxRegex(maxCharacterVinNumber), {
          message: `La cantidad de carácteres no puede ser mayor a ${maxCharacterVinNumber}`,
        }),
      otherwise: string().notRequired(),
    }),
    licensePlate: string().when('hasLicense', {
      is: false,
      then: string()
        .required('El campo de placa es obligatorio')
        .matches(createEqualCantRegex(equalCharacterLicensePlate), {
          message: `La cantidad de carácteres debe ser igual a ${equalCharacterLicensePlate}`,
        }),
      otherwise: string().notRequired(),
    }),
    serialMotor: string().when('isCollective', {
      is: true,
      then: string()
        .required('El campo del número de motor es obligatorio')
        .matches(createMaxRegex(maxCharacterSerialMotor), {
          message: `La cantidad de carácteres no puede ser mayor a ${maxCharacterSerialMotor}`,
        }),
      otherwise: string().nullable(),
    }),
  });
};

export default makeValidationSchema;
